/**
 * Connection status indicator.
 * @module features/p2p-chat/components/StatusBar
 */

import { Badge } from '@/shared/components/ui/badge';
import { BadgeVariant } from '@/shared/types/badge.types';
import type { ConnectionStatus } from '../types/p2pChat.types';

interface StatusBarProps {
  readonly status: ConnectionStatus;
  readonly error: Error | null;
}

const STATUS_LABEL: Readonly<Record<ConnectionStatus, string>> = {
  idle: 'Готов',
  connecting: 'Свързване…',
  'awaiting-peer': 'Изчакване на другия участник…',
  handshaking: 'Размяна на ключове…',
  connected: 'Свързан · криптирано',
  disconnected: 'Прекъсната връзка',
  failed: 'Неуспешно',
};

const STATUS_VARIANT: Readonly<Record<ConnectionStatus, BadgeVariant>> = {
  idle: BadgeVariant.Outline,
  connecting: BadgeVariant.Secondary,
  'awaiting-peer': BadgeVariant.Secondary,
  handshaking: BadgeVariant.Secondary,
  connected: BadgeVariant.Default,
  disconnected: BadgeVariant.Outline,
  failed: BadgeVariant.Destructive,
};

export function StatusBar({ status, error }: StatusBarProps) {
  return (
    <div className="flex items-center gap-3 border-b border-border bg-card px-4 py-2">
      <Badge variant={STATUS_VARIANT[status]}>{STATUS_LABEL[status]}</Badge>
      {error && (
        <span className="text-xs text-destructive" role="alert">
          {error.message}
        </span>
      )}
    </div>
  );
}
